import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    private _token = signal<string | null>(null)

    public get(): Signal<string | null> {
        return this._token
    }

    public set(value: string | null): void {
        this._token.set(value)
    }
}
